export default __webpack_public_path__ + "static/gfgsfgfs-1-64b382d2db4d8cbf30d11e3958fe2f9f.svg";